<template>
  <div>
    <h6 class="mb-4">Please provide your email to recover your username</h6>
    <SInput
      inputId="current-email"
      name="current-email"
      label="Email"
      ref="email"
      fieldClass="form-input"
      :autofocus="true"
      :required="true"
    />
    <SButtonMaterial
      class="recover-action"
      buttonType="button"
      color="primary"
      textColor="white"
      size="default"
      materialClass="dense"
      text="recover username"
      @button="submit"
    />
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SInput from "@/material-components/atoms/SInput.vue";
import UserHelperVue from '../../mixins/UserHelper.vue';
export default {
  name: "SRecoverUsernameForm",
  mixins: [UserHelperVue],
  data() {
    return {
      email: null,
    };
  },
  components: {
    SButtonMaterial,
    SInput,
  },
  methods: {
    submit() {
      this.$emit("forgot");
      this.forgotUsername(this.$refs.email.content);
    },
  }
};
</script>
